<template lang="pug">
  - $image_path = '@/assets/images/top/';
  .page-top
    button.button-sound(@click="setIsMute")
      img(v-if="isMute" src=`${$image_path}button_sound_off.png`)
      img(v-else="isMute" src=`${$image_path}button_sound.png`)
    .button-campaign(ref="campaign")
      router-link(:to="{ name:'campaign' }" @click.native="playSound('se_click_button')")
        img(src=`${$image_path}button_campaign.png`)
    .button-record(ref="record")
      router-link(:to="{ name:'record' }" @click.native="playSound('se_click_button')")
        img(src=`${$image_path}button_record.png`)
    .button-start(ref="start")
      a(@click="clickStart"): img(src=`${$image_path}button_start.png`)
    ul.link
      li.link-target
        router-link(:to="{ name:'target' }" @click.native="playSound('se_move_view')")
          img(src=`${$image_path}text_target.png`)
      li.link-separate: img(src=`${$image_path}text_separate.png`)
      li.link-rule
        router-link(:to="{ name:'rule' }" @click.native="playSound('se_move_view')")
          img(src=`${$image_path}text_rule.png`)
    .link-campaign
      a(href="../" @click="playSound('se_move_view')")
        img(src=`${$image_path}text_campaign.png`)
    .animation(ref="top")
</template>

<script>
import { TweenMax, TimelineMax } from 'gsap';

import CookieData from '@/assets/js/CookieData';
import SoundController from '@/assets/js/SoundController';
import PreloadAnimation from '@/assets/js/data/preloadAnimation';

export default {
  name: 'Top',
  data() {
    return {
      timeline: null,
      topAnimation: null,
      topAnimationTimer: null,
      isStartUIAnimtion: false,
      isMute: CookieData.isMute
    };
  },
  beforeDestroy() {
    SoundController.stopAll();
    clearInterval(this.topAnimationTimer);
    if (this.isStartUIAnimtion) this.timeline.pause();
    if (this.topAnimation) this.topAnimation.goToAndStop(0);
  },
  mounted() {
    TweenMax.set(this.$refs.campaign, { x: 30, opacity: 0 });
    TweenMax.set(this.$refs.record, { x: 30, opacity: 0 });
    TweenMax.set(this.$refs.start, { y: 30, opacity: 0 });

    PreloadAnimation.load(this.$refs.top, 'top').then(({ bodymovin }) => {
      bodymovin.addEventListener('complete', () => {
        clearInterval(this.topAnimationTimer);
      });
      this.topAnimation = bodymovin;
      bodymovin.goToAndPlay(0);

      this.topAnimationTimer = setInterval(() => {
        if (!this.isStartUIAnimtion && bodymovin.currentFrame >= 35) {
          this.isStartUIAnimtion = true;
          this.startAnimation();
        }
      }, 100);
    });

    SoundController.play('jingle_title');
  },
  methods: {
    clickStart() {
      SoundController.play('se_click_button');
      if (CookieData.isAlreadyStart) {
        this.$router.push({ name: 'game' });
      } else {
        CookieData.setIsAlreadyStart(true);
        this.$router.push({ name: 'rule' });
      }
    },
    setIsMute() {
      CookieData.setIsMute(!CookieData.isMute);
      SoundController.mute(CookieData.isMute);
      SoundController.play('se_click_button');
      this.isMute = CookieData.isMute;
    },
    playSound(key) {
      SoundController.play(key);
    },
    startAnimation() {
      this.timeline = new TimelineMax()
        .to(this.$refs.start, { y: 0, opacity: 1, delay: 0.5 })
        .to(this.$refs.campaign, { x: 0, opacity: 1, duration: 0.2 })
        .to(this.$refs.record, { x: 0, opacity: 1, duration: 0.2 });
    }
  }
};
</script>

<style scoped lang="scss">
.page-top {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: vw(1980);
  background-color: map-get($primary_color, 'grass');
  .button-sound {
    position: absolute;
    top: vw(43);
    right: vw(48);
    width: vw(180);
    z-index: 1;
  }
  .button-campaign {
    position: absolute;
    top: vw(812);
    right: vw(41);
    width: vw(276);
    z-index: 1;
    a {
      display: block;
    }
  }
  .button-record {
    position: absolute;
    top: vw(1114);
    right: vw(41);
    width: vw(276);
    z-index: 1;
    a {
      display: block;
    }
  }
  .button-start {
    position: absolute;
    top: vw(1503);
    left: vw(190);
    width: vw(916);
    z-index: 1;
    a {
      display: block;
    }
  }
  .link {
    display: flex;
    justify-content: center;
    position: absolute;
    top: vw(1780);
    left: vw(197);
    width: vw(897);
    z-index: 1;
    a {
      display: block;
    }
    &-separate {
      width: vw(44);
      margin: 0 vw(45);
    }
    &-terms {
      width: vw(201);
    }
    &-target {
      width: vw(199);
    }
    &-rule {
      width: vw(243);
    }
  }
  .link-campaign {
    display: flex;
    justify-content: center;
    position: absolute;
    top: vw(1860);
    left: 0;
    width: 100%;
    z-index: 1;
    a {
      display: block;
      width: vw(405);
      margin: 0 auto;
    }
  }
  .animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
  }
}
</style>
